import { useAuth } from '@/services/auth';
import { useClientKey } from '@/state/agent';
import theme from '@/theme';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { StitchButtons } from '../StitchButtons';
import { Playground } from './Playground';

const Container = styled.div`
    flex: 40%;
    background: ${theme.colors.black[100]};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    @media (max-width: 1096px) {
        display: none;
    }
`;

const ButtonsContainer = styled.div`
    margin: auto;
`;

interface Props {
    enableStitchSelection?: boolean;
    agentId: string;
}

export const PlaygroundContainerV1 = observer(({ enableStitchSelection, agentId }: Props) => {
    const { isAnonymous } = useAuth();
    const { data: clientKey } = useClientKey({ isAnonymous });

    if (!clientKey) return;

    return (
        <Container>
            <Playground agentId={agentId} clientKey={clientKey?.client_key} />
            {enableStitchSelection && (
                <ButtonsContainer>
                    <StitchButtons hideTooltip />
                </ButtonsContainer>
            )}
        </Container>
    );
});
